export const name = 'minimumLength';
/**
 * Determines if value length is less than min value passed in
 *
 * @param value Value to make determination against
 * @param min Integer value to check against value
 */
const minimumLength = async (value, min) => (value.trim().length >= min);
minimumLength.defaultMessage = 'Field is too short';
export { minimumLength };
